import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { FileRestrictions, UploadComponent, UploadEvent } from '@progress/kendo-angular-upload';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LoadingService } from '../../../layout/loading.service';

@Component({
    selector: 'ns-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileUploadComponent),
            multi: true
        },
    ]
})
export class FileUploadComponent implements OnInit, ControlValueAccessor {
    @Input() disabled: boolean = false;
    @Input() softRemove: boolean = true;
    @Input() fileId = null;
    @Input() originalName = null;
    @Input() formGroup: FormGroup;
    @ViewChild(UploadComponent) uploadComponent: UploadComponent;


    public fileRestrictions: FileRestrictions = {
        minFileSize: 1,
        allowedExtensions: ['.jpg', '.png']
    };

    constructor(
        protected loadingService: LoadingService
    ) {
    }

    ngOnInit() {
        this.onChange = (_: any) => {
        };
        this.onTouched = () => {
        };
        this.disabled = false;
    }

    onChange: any = () => {
    }

    onTouched: any = () => {
    }

    uploadEventHandler(e: UploadEvent) {
        this.loadingService.start();

        e.data = {
            upFile: e.files[0].rawFile
        };
    }

    successEventHandler(event) {
        if (event && event.response && event.response.body && event.response.body.id) {
            this.fileId = event.response.body.id;
            this.originalName = event.response.body.originalName;

            this.formGroup.get('originalName').setValue(this.originalName);
            this.formGroup.get('id').setValue(this.fileId);
        } else {
            this.fileId = undefined;
            this.originalName = undefined;
        }
        this.onChange(
            {
                id: this.fileId,
                originalName: this.originalName
            }
        );

        this.loadingService.stop();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
    }

    writeValue(obj: any): void {
    }

    errorEventHandler(event) {
    }

    removeAfterUpload() {
        if (!this.softRemove) {
            const fileUid = this.uploadComponent.fileList.files[0][0].uid;
            this.uploadComponent.removeFilesByUid(fileUid);
        }
        this.fileId = undefined;
        this.onChange(undefined);
    }
}
